export const getSearchBarFilter = state => state.reports.searchBarFilter;
export const getOpenedAccordion = state => state.reports.openedAccordion;
export const getReportFiltersState = state => state.reports.reportFiltersState;
